export default __webpack_public_path__ + "static/media/figuremap72.b0d0d0a5.png";